/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetContactItemDivider
 */
export interface GetContactItemDivider {
    /**
     * 
     * @type {string}
     * @memberof GetContactItemDivider
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetContactItemDivider
     */
    isdivider: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetContactItemDivider
     */
    label: string;
}

export function GetContactItemDividerFromJSON(json: any): GetContactItemDivider {
    return GetContactItemDividerFromJSONTyped(json, false);
}

export function GetContactItemDividerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetContactItemDivider {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'isdivider': json['isdivider'],
        'label': json['label'],
    };
}

export function GetContactItemDividerToJSON(value?: GetContactItemDivider | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'isdivider': value.isdivider,
        'label': value.label,
    };
}


